import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import EmptyHeader from "./EmptyHeader";
import { sendIsUserRegistered, sendUserPhoneOrEmail } from "../services/auth";
import { isDevelopmentMode } from "../services/base";

export default function Sign() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, seterror] = useState({ mobile: "", email: "" });
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [choose, setChoose] = useState("mobile");
  const [flag, setflag] = useState(false);
  const navigate = useNavigate();
  const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

  function handlechoose() {
    setChoose("email");
  }

  function handlechooseMobile() {
    setChoose("mobile");
  }

  function handelCheck(event) {
    event.preventDefault();
    var tagName = event.target.name;
    let p = event.target.value;

    if (tagName == "mobile") {
      const phoneEng = p2e(p);
      setPhone(phoneEng);
      var pattern = new RegExp(/^09[0-9]{9}/);

      if (!pattern.test(phoneEng)) {
        seterror({
          ...error,
          mobile: "لطفا شماره تلفن خود را درست وارد نمایید",
        });
        setflag(true);
      } else if (phoneEng.length == 11) {
        seterror({ ...error, mobile: "" });
        setflag(false);
      } else {
        seterror({
          ...error,
          mobile: "لطفا شماره تلفن خود را درست وارد نمایید",
        });
        setflag(true);
      }
    } else {
      var pattern = /\S+@\S+\.\S+/;
      if (pattern.test(p)) {
        seterror({ ...error, email: "" });
        setEmail(p);
        setflag(false);
      } else {
        setflag(true);
        seterror({ ...error, email: "لطفا ایمیل خود را درست وارد نمایید" });
      }
    }
  }

  function sendOtp(is_registered) {
    let formData = new FormData();

    if (phone) {
      formData.append(
        isDevelopmentMode() ? "identifier" : "destination_address",
        phone
      );
    } else if (email) {
      formData.append(
        isDevelopmentMode() ? "identifier" : "destination_address",
        email
      );
    }
    return sendUserPhoneOrEmail(formData, is_registered);
  }

  function handelSubmit() {
    let formData = new FormData();
    if (phone) {
      formData.append(
        isDevelopmentMode() ? "identifier" : "destination_address",
        phone
      );
    } else if (email) {
      formData.append(
        isDevelopmentMode() ? "identifier" : "destination_address",
        email
      );
    }

    setIsLoading(true);
    sendIsUserRegistered(formData).then((res) => {
      sendOtp(res.data?.data?.is_registered).then((result) => {
        if (result) {
          navigate("/verify", {
            state: {
              islog: res.data.data.is_registered,
              phone: phone,
              email: email,
              activeMethod: choose,
            },
          });
        } else {
          setIsLoading(false);
          toast.error("فرایند به طور کامل انجام نشد مجددا تلاش فرمایید");
        }
      });
    });
  }

  return (
    <>
      <div>
        <EmptyHeader />
        <form className="text-center">
          <h3 className="title-for-login title-for-login-desktop reset-margin-title">
            ورود به حساب کاربری
          </h3>
          <div className="container">
            <div className="row justify-content-center h-100 section-padding align-items-center">
              <div className="col-xl-6 col-md-8">
                <div className="row">
                  <div className="col-6 text-start">
                    <button
                      type="button"
                      id={"mobile"}
                      name="mobile"
                      className={
                        "btn-choose btn-330" +
                        (choose === "mobile" ? "" : " not-active-login")
                      }
                      onClick={handlechooseMobile}
                    >
                      از طریق موبایل
                    </button>
                  </div>

                  <div className="col-6 text-end">
                    <button
                      type="button"
                      id={"email"}
                      name="email"
                      className={
                        "btn-choose btn-331" +
                        (choose === "email" ? "" : " not-active-login")
                      }
                      onClick={handlechoose}
                    >
                      از طریق ایمیل
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="authincation section-padding">
            <div className="container h-100">
              <div className="row justify-content-center h-100 align-items-center">
                <div className="col-xl-6 col-md-8">
                  <div className="mini-logo text-center my-2"></div>
                  <div className="auth-form custom-shadow">
                    <form>
                      <div className="form-group mt-3 text-end">
                        {choose == "mobile" ? (
                          <>
                            <span className="pe-2 mynormal">شماره موبایل</span>

                            <div className="input-group mb-3 pt-1">
                              <input
                                onKeyDown={(e) => {
                                  if (e.key.toLowerCase() === "enter") {
                                    e.preventDefault();
                                    handelSubmit();
                                  }
                                }}
                                type="tel"
                                className="form-control mt-2 myinput ltr"
                                placeholder="مثال ۰۹۱۲۳۴۵۶۷۸۹"
                                id={"mobilein"}
                                name={"mobile"}
                                value={phone}
                                onChange={handelCheck}
                                required
                              />
                            </div>

                            <div className={"text-danger h6 text-large"}>
                              {error.mobile}
                            </div>
                          </>
                        ) : (
                          <>
                            <span className="pe-2 mynormal">ایمیل</span>

                            <div className="input-group mb-3 pt-1">
                              <input
                                type="email"
                                onKeyDown={(e) => {
                                  if (e.key.toLowerCase() === "enter") {
                                    e.preventDefault();
                                    handelSubmit();
                                  }
                                }}
                                className="form-control mt-2 myinput ltr"
                                placeholder=" talaeishow@gmail.com مثال "
                                id={"emailin"}
                                name={"email"}
                                onChange={handelCheck}
                                required
                              />
                            </div>

                            <div className={"text-danger h6 text-large"}>
                              {error.email}
                            </div>
                          </>
                        )}
                      </div>
                      <div className="text-center pt-4 w-100">
                        <button
                          disabled={flag}
                          type="button"
                          className="btn w-100 btn-submit btn-block spinner-button py-2"
                          id="submit"
                          data-loading-text="<i className='fas fa-spinner fa-pulse'></i>"
                          onClick={handelSubmit}
                        >
                          {isLoading ? (
                            <img
                              src={"./loading.svg"}
                              alt={""}
                              className={"w-loading"}
                            />
                          ) : (
                            <span>ورود</span>
                          )}
                        </button>
                        <div className="pt-3">
                          با ورود به طلایی‌شو{" "}
                          <Link to={"/privacy"} className="text-custom">
                            قوانین و شرایط حریم خصوصی{" "}
                          </Link>
                          را می‌پذیرم.
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
